import { useState, useEffect } from "react";

import { get } from "library/endpoints";

/**
 * useParentSupportCategories
 * @returns 
 */
export default function useParentSupportCategories({ effectId }) {
  const [supportParentCategories, setSupportParentCategories] = useState(null);

  useEffect(() => {
    if (!supportParentCategories) {
      fetchSupportParentCategories();
    }
  }, []) // eslint-disable-line

  const fetchSupportParentCategories = async () => {
    try {
      const {data} = await get(`/frontend/support-parent-categories/effect/${effectId}`)      
      setSupportParentCategories(data)
    } catch (err) {
      console.log(err)
    }
  }

  return {
    supportParentCategories,
    fetchSupportParentCategories
  }
}